var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-wrapper"},[_c('Button',{attrs:{"title":_vm.label},nativeOn:{"click":function($event){return _vm.handleAction()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }